import PlansList from '#/features/plans/components/PlansList'
import { PLAN_CONTENT } from '#/data/plans'
import { RevealItem, ScrollReveal } from '#/components/common/ScrollReveal'
import { TextAnimate } from '#/components/common/TextAnimate'
import { HighlightText } from '#/components/common/HighlightText'
import headerIcon from '#/assets/header-icon.svg'

interface PlansSectionProps {
  className?: string
}

export default function PlansSection({ className = '' }: PlansSectionProps) {
  return (
    <section className={`w-full py-16 ${className}`}>
      <div className="container mx-auto px-4 flex flex-col gap-12">
        {/* Header */}
        <ScrollReveal className="flex flex-col items-center gap-4 text-center">
          <RevealItem>
            <img alt="" src={headerIcon} className="mx-auto" />
          </RevealItem>
          <RevealItem>
            <p className="text-sm font-semibold uppercase tracking-[0.3em] text-primary-700">
              {PLAN_CONTENT.eyebrow}
            </p>
          </RevealItem>
          <RevealItem className="w-full">
            <h2 className="text-4xl font-bold text-neutral-900 sm:text-5xl">
              {PLAN_CONTENT.title}{' '}
              <HighlightText
                inView
                text={PLAN_CONTENT.subtitle}
                className="bg-linear-to-r from-primary-100/70 to-primary-300/70 text-neutral-900"
              />
            </h2>
          </RevealItem>
          <RevealItem className="max-w-2xl mx-auto">
            <TextAnimate
              by="word"
              animation="fadeIn"
              duration={1.1}
              className="text-base text-neutral-500 sm:text-lg"
            >
              {PLAN_CONTENT.description}
            </TextAnimate>
          </RevealItem>
        </ScrollReveal>

        {/* Plans Grid — 3 Duration Cards */}
        <div className="mt-4">
          <PlansList />
        </div>
      </div>
    </section>
  )
}
